import axios from 'axios'
import {
  SET_CONTACTS,
  SET_CURRENT_CONTACT,
  SET_CURRENT_PRODUCT,
  SET_CURRENT_VENDOR,
  SET_VENDORS,
  UPDATE_CONTACT,
  UPDATE_VENDOR,
  GET_SUBMITTED_PRODUCTS,
  GET_IN_REVIEW_PRODUCTS,
  GET_APPROVED_REJECTED_PRODUCTS,
  CLEAR_CURRENT_PRODUCT,
  UPDATE_CURRENT_PRODUCT,
  REPLACE_CURRENT_PRODUCT,
  ADD_CURRENT_PRODUCT,
  DELETE_CURRENT_PRODUCT,
  SET_SAVING,
} from 'context/types'
import NotificationAlert from 'react-notification-alert'
import FileSaver from 'file-saver'
import { PropTypes } from 'prop-types'
import React, { useContext, useReducer, useRef } from 'react'
import * as XLSX from 'xlsx'
import ProductContext from './productContext'
import ProductReducer from './productReducer'
import AuthContext from 'context/auth/authContext'
import SubmitContext from 'context/submit/submitContext'
import { loadProducts } from 'context/Utilities'
import {
  IN_REVIEW_STATUS,
  REJECTED_STATUS,
  APPROVED_STATUS,
} from '../../variables/categories'
const apiUrl = window.config.apiUrl

const productURL = `${apiUrl}/products`

const ProductState = ({ children }) => {
  const initialState = {
    products: null,
    current: null,
    contacts: null,
    vendors: null,
    contact: null,
    vendor: null,
    saving: false,
  }

  const [state, dispatch] = useReducer(ProductReducer, initialState)
  const authContext = useContext(AuthContext)
  const { timeout } = authContext

  const submitContext = useContext(SubmitContext)
  const { addProduct } = submitContext

  /* react-notification-alert Start */
  const notificationAlert = useRef()
  const notifyContactSuccess = () => {
    let options = {
      place: 'bc',
      message: (
        <div>
          <h5>Contact has been successfully updated.</h5>
        </div>
      ),
      type: 'success',
      icon: 'nc-icon nc-bell-55',
      autoDismiss: 3,
    }
    notificationAlert.current.notificationAlert(options)
  }
  const notifyContactFail = () => {
    let options = {
      place: 'bc',
      message: (
        <div>
          <h5>Contact has failed to update.</h5>
        </div>
      ),
      type: 'danger',
      icon: 'nc-icon nc-bell-55',
      autoDismiss: 3,
    }
    notificationAlert.current.notificationAlert(options)
  }
  /* react-notification-alert End */

  const loadProductImages = async pkProduct => {
    const config = { headers: { 'Content-Type': 'application/json' } }

    let images = []

    await axios
      .get(`${productURL}/image/${pkProduct}`, config)
      .then(response => {
        if (response.data.statusCode === 200) {
          images = JSON.parse(response.data.result)
        }
      })

    while (images.length < 4) {
      images.push({
        fkProduct: 0,
        pkProductImage: 0,
        ImageName: '',
        ImageType: '',
        ProdImg: '',
      })
    }

    console.log('images in loadProductImages is: ' + JSON.stringify(images))
    return images
  }

  // Get all submitted products
  const getSubmittedProducts = async () => {
    try {
      await axios
        .get(`${apiUrl}/products/submitted`)
        .then(response => JSON.parse(response.data.result))
        .then(products => {
          console.log(
            'getSubmittedProducts products is: ' + JSON.stringify(products)
          )
          loadProducts(products, GET_SUBMITTED_PRODUCTS, dispatch)
        })
    } catch (err) {
      console.log('Get SubmittedProducts Error: ', err.response)
      if (err?.response?.status === 401) {
        timeout()
      }
    }
  }

  // Get submitted brand specific products
  const getSubmittedBSProducts = async () => {
    try {
      await axios
        .get(`${apiUrl}/products/submittedbs`)
        .then(response => JSON.parse(response.data.result))
        .then(products => {
          console.log(
            'getSubmittedBSProducts products is: ' + JSON.stringify(products)
          )
          loadProducts(products, GET_SUBMITTED_PRODUCTS, dispatch)
        })
    } catch (err) {
      console.log('getSubmittedBSProducts Error: ', err.response)
      if (err?.response?.status === 401) {
        timeout()
      }
    }
  }

  // Get submitted non-brand specific products
  const getSubmittedNBSProducts = async () => {
    try {
      await axios
        .get(`${apiUrl}/products/submittednbs`)
        .then(response => JSON.parse(response.data.result))
        .then(products => {
          console.log(
            'getSubmittedNBSProducts products is: ' + JSON.stringify(products)
          )
          loadProducts(products, GET_SUBMITTED_PRODUCTS, dispatch)
        })
    } catch (err) {
      console.log('getSubmittedNBSProducts Error: ', err.response)
      if (err?.response?.status === 401) {
        timeout()
      }
    }
  }

  // Get all in-review products
  const getInReviewProducts = async () => {
    try {
      await axios
        .get(`${apiUrl}/products/inreview`)
        .then(response => JSON.parse(response.data.result))
        .then(products => {
          console.log(
            'getInReviewProducts products is: ' + JSON.stringify(products)
          )
          loadProducts(products, GET_IN_REVIEW_PRODUCTS, dispatch)
        })
    } catch (err) {
      console.log('getInReviewProducts Error: ', err.response)
      if (err?.response?.status === 401) {
        timeout()
      }
    }
  }

  // Get in-review brand specific products
  const getInReviewBSProducts = async () => {
    try {
      await axios
        .get(`${apiUrl}/products/inreviewbs`)
        .then(response => JSON.parse(response.data.result))
        .then(products => {
          console.log(
            'getInReviewBSProducts products is: ' + JSON.stringify(products)
          )
          loadProducts(products, GET_IN_REVIEW_PRODUCTS, dispatch)
        })
    } catch (err) {
      console.log('getInReviewBSProducts Error: ', err.response)
      if (err?.response?.status === 401) {
        timeout()
      }
    }
  }

  // Get in-review non-brand specific products
  const getInReviewNBSProducts = async () => {
    try {
      await axios
        .get(`${apiUrl}/products/inreviewnbs`)
        .then(response => JSON.parse(response.data.result))
        .then(products => {
          console.log(
            'getInReviewNBSProducts products is: ' + JSON.stringify(products)
          )
          loadProducts(products, GET_IN_REVIEW_PRODUCTS, dispatch)
        })
    } catch (err) {
      console.log('getInReviewNBSProducts Error: ', err.response)
      if (err?.response?.status === 401) {
        timeout()
      }
    }
  }

  // Get all approved or rejected products
  const getReviewedProducts = async () => {
    try {
      await axios
        .get(`${apiUrl}/products/reviewed`)
        .then(response => JSON.parse(response.data.result))
        .then(products => {
          console.log(
            'getReviewedProducts products is: ' + JSON.stringify(products)
          )
          loadProducts(products, GET_APPROVED_REJECTED_PRODUCTS, dispatch)
        })
    } catch (err) {
      console.log('getReviewedProducts Error: ', err.response)
      if (err?.response?.status === 401) {
        timeout()
      }
    }
  }

  // Get all approved or rejected brand specific products
  const getReviewedBSProducts = async () => {
    try {
      await axios
        .get(`${apiUrl}/products/reviewedbs`)
        .then(response => JSON.parse(response.data.result))
        .then(products => {
          console.log(
            'getReviewedBSProducts products is: ' + JSON.stringify(products)
          )
          loadProducts(products, GET_APPROVED_REJECTED_PRODUCTS, dispatch)
        })
    } catch (err) {
      console.log('getReviewedBSProducts Error: ', err.response)
      if (err?.response?.status === 401) {
        timeout()
      }
    }
  }

  // Get all approved or rejected non-brand specific products
  const getReviewedNBSProducts = async () => {
    try {
      await axios
        .get(`${apiUrl}/products/reviewednbs`)
        .then(response => JSON.parse(response.data.result))
        .then(products => {
          console.log(
            'getReviewedNBSProducts products is: ' + JSON.stringify(products)
          )
          loadProducts(products, GET_APPROVED_REJECTED_PRODUCTS, dispatch)
        })
    } catch (err) {
      console.log('getReviewedNBSProducts Error: ', err.response)
      if (err?.response?.status === 401) {
        timeout()
      }
    }
  }

  // Get Contacts
  const getContacts = async () => {
    try {
      await axios.get(`${apiUrl}/contacts/getallcontacts`).then(res => {
        const currentContacts = JSON.parse(res.data.result)
        const filteredContacts = currentContacts.filter(
          contact => !contact.conEmail.includes('ca.gov')
        )
        dispatch({
          type: SET_CONTACTS,
          payload: filteredContacts,
        })
      })
    } catch (err) {
      console.log('Get Contacts Error: ', err.response?.msg)
      if (err?.response?.status === 401) {
        timeout()
      }
    }
  }

  // Get Vendors
  const getVendors = async () => {
    try {
      await axios.get(`${apiUrl}/vendors/getallvendors`).then(res =>
        dispatch({
          type: SET_VENDORS,
          payload: JSON.parse(res.data.result),
        })
      )
    } catch (err) {
      console.log('Get Vendors Error: ', err.response?.msg)
      if (err?.response?.status === 401) {
        timeout()
      }
    }
  }

  const updateContact = async contact => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }

    try {
      await axios
        .put(`${apiUrl}/contacts/${contact.pkContact}`, contact, config)
        .then(res =>
          dispatch({
            type: UPDATE_CONTACT,
            payload: JSON.parse(res.config.data),
          })
        )
    } catch (err) {
      console.error('Update Contact Error: ', err.response?.msg)
    }
  }

  const updateVendor = async vendor => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }

    try {
      await axios
        .put(`${apiUrl}/vendors/${vendor.pkVendor}`, vendor, config)
        .then(res =>
          dispatch({
            type: UPDATE_VENDOR,
            payload: JSON.parse(res.config.data),
          })
        )
    } catch (err) {
      console.error('Update Vendor Error: ', err.response?.msg)
    }
  }

  const addProductReviewer = async product => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }
    try {
      console.log(
        'product before addProduct in addProductReviewer: ' +
          JSON.stringify(product)
      )
      addProduct(product).then(res => {
        console.log('res in addProductReviewer is: ' + JSON.stringify(res))
        product.pkProduct = res.pkProduct
        product.fkProduct = res.pkProduct
        axios.post(`${apiUrl}/products/review`, product, config).then(res2 => {
          console.log('res2 in addProductReviewer is: ' + JSON.stringify(res2))
        })
      })
      dispatch({
        type: ADD_CURRENT_PRODUCT,
        payload: product,
      })
    } catch (err) {
      console.log('addProductReviewer Error: ', err.response.msg)
    }
  }

  // Update Product
  const updateProduct = async (product, save) => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }

    const productWithoutReview = {
      ...product,
      ReviewOneApproved: null,
      ReviewTwoApproved: null,
    }

    try {
      switch (product.fkApprovalStatus) {
        case IN_REVIEW_STATUS:
          await axios
            .post(`${apiUrl}/products/review`, product, config)
            .then(res => {
              console.log(
                'res in post updateReviewStatus is: ' +
                  JSON.stringify(res.config.data)
              )
            })
          break
        case APPROVED_STATUS:
        case REJECTED_STATUS:
          await axios
            .put(`${apiUrl}/products/review`, product, config)
            .then(res => {
              console.log(
                'res in post updateReviewStatus is: ' +
                  JSON.stringify(res.config.data)
              )
            })
          break
        default:
          break
      }
    } catch (err) {
      console.log('Update Product Review Error: ', err.response)
    }

    try {
      await axios
        .put(`${apiUrl}/products/${product.UPC}`, productWithoutReview, config)
        .then(res => {
          if (!save) {
            dispatch({
              type: UPDATE_CURRENT_PRODUCT,
              payload: JSON.parse(res.config.data),
            })
          }
        })
    } catch (err) {
      console.log('Update Product Error: ', err.response.msg)
    }
  }

  const replaceProduct = async product => {
    console.log('product before replaceProduct: ' + JSON.stringify(product))
    await deleteProduct(product, product.oldUPC)
    await addProductReviewer(product)
    dispatch({
      type: REPLACE_CURRENT_PRODUCT,
      payload: product,
    })
  }

  // Delete Product
  const deleteProduct = async (product, UPC, save) => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }
    let url = null
    switch (product?.fkCategory) {
      case '02':
        url = `${apiUrl}/products/cheese/upc/${UPC}`
        break
      case '03':
        url = `${apiUrl}/products/eggs/upc/${UPC}`
        break
      case '06':
        switch (product?.fkSubCategory) {
          case '001':
            url = `${apiUrl}/products/legumes/Peanut Butter/upc/${UPC}`
            break
          case '002':
            url = `${apiUrl}/products/legumes/Dry Beans, Peas, Lentils/upc/${UPC}`
            break
          case '003':
            url = `${apiUrl}/products/legumes/Canned Mature Beans/upc/${UPC}`
            break
          default:
            break
        }
        break
      case '08':
        url = `${apiUrl}/products/cannedfish/upc/${UPC}`
        break
      case '12':
        url = `${apiUrl}/products/infant/fruitsandvegetables/upc/${UPC}`
        break
      case '13':
        url = `${apiUrl}/products/infant/meats/upc/${UPC}`
        break
      case '16':
        switch (product?.fkSubCategory) {
          case '001':
            url = `${apiUrl}/products/wholegrains/Whole Grain Bread/upc/${UPC}`
            break
          case '003':
            url = `${apiUrl}/products/wholegrains/Brown Rice/upc/${UPC}`
            break
          case '004':
            url = `${apiUrl}/products/wholegrains/Bulgur/upc/${UPC}`
            break
          case '005':
            url = `${apiUrl}/products/wholegrains/Oats or Oatmeal/upc/${UPC}`
            break
          case '006':
            url = `${apiUrl}/products/wholegrains/Barley/upc/${UPC}`
            break
          default:
            break
        }
        break
      case '51':
        url = `${apiUrl}/products/milk/Whole Milk/upc/${UPC}`
        break
      case '52':
        url = `${apiUrl}/products/milk/Reduced Fat/upc/${UPC}`
        break
      case '54':
        url = `${apiUrl}/products/juice/upc/${UPC}`
        break
      case '19':
        switch (product?.fkSubCategory) {
          case '002':
            url = `${apiUrl}/products/fruitsandvegetables/${product?.FrozenProductType}/frozen/upc/${UPC}`
            break
          case '003':
            url = `${apiUrl}/products/fruitsandvegetables/${product?.CannedProductType}/canned/upc/${UPC}`
            break
          case '004':
            url = `${apiUrl}/products/legumes/Dried Fruits/upc/${UPC}`
            break
          default:
        }
        break
      default:
        console.log('fkCategory is: ' + product?.fkCategory)
    }
    try {
      await axios.delete(url, config)
      dispatch({ type: DELETE_CURRENT_PRODUCT, payload: UPC })
      if (!save) {
        dispatch({ type: CLEAR_CURRENT_PRODUCT })
      }
    } catch (err) {
      console.log('Delete Product Error: ', JSON.stringify(err))
    }
  }

  // Set Current Product
  const setCurrentProduct = UPC => {
    dispatch({ type: SET_CURRENT_PRODUCT, payload: UPC })
  }

  // Clear Current Product
  const clearCurrent = () => {
    dispatch({ type: CLEAR_CURRENT_PRODUCT })
  }

  // Set Current Contact
  const setCurrentContact = id => {
    dispatch({ type: SET_CURRENT_CONTACT, payload: id })
    console.log('id is: ' + id)
  }

  // Set Current Vendor
  const setCurrentVendor = id => {
    dispatch({ type: SET_CURRENT_VENDOR, payload: id })
  }

  const setSaving = saving => {
    dispatch({ type: SET_SAVING, payload: saving })
  }

  const getProduct = UPC => {
    return state.products.find(product => product.UPC === UPC)
  }

  const formatExportData = data => {
    let formattedData = []

    data.forEach(product => {
      const date = new Date(product.ReviewTwoDate)
      console.log('r2date: ' + product.EffectiveDate)
      const effectiveDate = new Date(product.EffectiveDate)

      let fvType = ''
      if (product.fkCategory === '19') {
        const sub = product.fkSubCategory
        if (sub === '001FF') fvType = 5
        else if (sub === '001FV') fvType = 6
        else if (sub === '001CF') fvType = 8
        else if (sub === '001CV') fvType = 9
        else if (sub === '004') fvType = 10
      }

      formattedData.push({
        UPC: product.UPC,
        category: product.fkCategory,
        subcategory: product.fkSubCategory.replace(/\D/g, ''),
        manufacturer: product.Manufacturer,
        brandName: product.BrandName,
        foodDesc: product.ReviewerDescription,
        quantity: product.ExchangeSize,
        UoM: product.UoM,
        packageType: '',
        authDate: date.toLocaleDateString(),
        effectiveDate: effectiveDate.toLocaleDateString(),
        exchangeSize: product.ExchangeSize,
        authorized:
          product.ReviewOneApproved === 'Approved' &&
          product.ReviewTwoApproved === 'Approved'
            ? 'Y'
            : 'N',
        productDesc: product.ProductDesc,
        PLUIndicator: 'U',
        deactivationReason: '',
        deactivationDate: '01/01/2060',
        broadbandFlag: product.IsBroadband ? '1' : '0',
        UPCFormat: product.UPC.length,
        highPriceIndicator: 0,
        'Fruits and Vegetables Type': fvType,
      })
    })

    return formattedData
  }

  const exportData = (fileName, filtered) => {
    const fileType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    const fileExtension = '.csv'
    let ws
    filtered
      ? (ws = XLSX.utils.json_to_sheet(
          formatExportData(
            state.products.filter(
              product =>
                product.ReviewOneApproved === 'Approved' &&
                product.ReviewTwoApproved === 'Approved'
            )
          )
        ))
      : (ws = XLSX.utils.json_to_sheet(formatExportData(state.products)))

    const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
    const excelBuffer = XLSX.write(wb, { bookType: 'csv', type: 'array' })
    const exportingData = new Blob([excelBuffer], { type: fileType })
    FileSaver.saveAs(exportingData, fileName + fileExtension)
  }

  // ------------------------------ NEW: ProductsReport multi-sheet export ------------------------------

  // 1) Base columns must match formatExportData() exactly, in this order:
  const BASE_COLUMNS = [
    'UPC',
    'category',
    'subcategory',
    'manufacturer',
    'brandName',
    'foodDesc',
    'quantity',
    'UoM',
    'packageType',
    'authDate',
    'effectiveDate',
    'exchangeSize',
    'authorized',
    'productDesc',
    'PLUIndicator',
    'deactivationReason',
    'deactivationDate',
    'broadbandFlag',
    'UPCFormat',
    'highPriceIndicator',
    'Fruits and Vegetables Type',
  ]

  const EXTRA_XLSX_COLUMNS = ['Comments', 'SubmitterEmail']

  // 2) Utilities
  const toLocalDate = v => {
    if (!v) return ''
    try {
      const d = new Date(v)
      return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString()
    } catch {
      return ''
    }
  }

  const safeJsonParse = (s, fallback = {}) => {
    if (!s) return fallback
    if (typeof s === 'object') return s || fallback
    try {
      return JSON.parse(s) ?? fallback
    } catch {
      return fallback
    }
  }

  const groupBy = (arr, keyFn) =>
    arr.reduce((acc, item) => {
      const k = keyFn(item) ?? 'Unknown'
      ;(acc[k] = acc[k] || []).push(item)
      return acc
    }, {})

  const sanitizeSheetName = name =>
    String(name || 'Sheet')
      .replace(/[\[\]\:\*\?\/\\]/g, ' ')
      .substring(0, 31)
      .trim() || 'Sheet'

  // 3) Build one base row using the same mapping as formatExportData(), THEN append product-specific fields
  const buildBaseRow = p => {
    const authDate = toLocalDate(p.ActiveDate)
    const effective = toLocalDate(p.EffectiveDate)

    const authorized =
      p.ReviewOneApproved === 'Approved' && p.ReviewTwoApproved === 'Approved'
        ? 'Y'
        : 'N'

    // Logic for the specific 4 types
    let fvType = '' // Defaults to empty for all other products
    if (p.fkCategory === '19') {
      const sub = p.fkSubCategory
      if (sub === '001FF') fvType = '05'
      else if (sub === '001FV') fvType = '06'
      else if (sub === '001CF') fvType = '08'
      else if (sub === '001CV') fvType = '09'
      else if (sub === '004') fvType = '10'
    }

    return {
      // === columns identical to formatExportData ===
      UPC: p.UPC,
      category: p.fkCategory,
      subcategory: String(p.fkSubCategory || '').replace(/\D/g, ''),
      manufacturer: p.Manufacturer,
      brandName: p.BrandName,
      foodDesc: p.ReviewerDescription,
      quantity: p.ExchangeSize,
      UoM: p.UoM,
      packageType: '',
      authDate: authDate,
      effectiveDate: effective,
      exchangeSize: p.ExchangeSize,
      authorized,
      productDesc: p.ProductDesc,
      PLUIndicator: 'U',
      deactivationReason: '',
      deactivationDate: '01/01/2060',
      broadbandFlag: p.IsBroadband ? '1' : '0',
      UPCFormat: (p.UPC || '').length,
      highPriceIndicator: 0,
      'Fruits and Vegetables Type': fvType,
      Comments: p.Comments ?? '',
      SubmitterEmail: p.SubmitterEmail ?? '',
      // NOTE: we do NOT add ProductType/ProductTypeKey/etc here; the requirement
      // is to keep these columns identical, and then add product-specific fields to the right.
    }
  }

  // 4) Normalize rows: base mapping + flattened ProductSpecific fields
  const normalizeRowsForExport = rows => {
    return rows.map(p => {
      const base = buildBaseRow(p)
      const specific = safeJsonParse(p.ProductSpecific, {})

      // If ProductSpecific comes as array (rare), flatten first element
      const specificObj = Array.isArray(specific) ? specific[0] || {} : specific

      // Append product-specific fields after base columns (in insertion order)
      for (const [k, v] of Object.entries(specificObj)) {
        // Avoid clobbering base columns if keys collide
        if (!(k in base)) base[k] = v
      }

      return {
        row: base,
        productTypeKey: p.ProductTypeKey,
        productType: p.ProductType,
        subcategoryName: p.SubCategoryName || '',
      }
    })
  }

  /**
   * Export reports workbook (multi-sheet):
   * params: { brandMode, reviewedMode, from, to, category?, subcategory?, upc?, offset?, fetch? }
   * Sheets: one per (ProductTypeKey). Columns: BASE_COLUMNS + union of product-specific keys.
   */
  const exportReport = async params => {
    try {
      // Build query string
      const qp = new URLSearchParams()
      qp.set('brandMode', params.brandMode || 'ALL') // 'ALL' | 'BS' | 'NBS'
      qp.set('reviewedMode', params.reviewedMode || 'AUTHORIZED') // 'AUTHORIZED' | 'REVIEWED'
      if (params.from) qp.set('from', params.from)
      if (params.to) qp.set('to', params.to)
      if (params.category) qp.set('category', params.category)
      if (params.subcategory) qp.set('subcategory', params.subcategory)
      if (params.upc) qp.set('upc', params.upc)
      qp.set('offset', String(params.offset ?? 0))
      qp.set('fetch', String(params.fetch ?? 50000))

      const url = `${apiUrl}/products/report?${qp.toString()}`
      const res = await axios.get(url, { withCredentials: true })

      // Envelope: { statusCode, message, result }
      if (Number(res?.data?.statusCode) !== 200) {
        const msg = res?.data?.message || 'Report failed'
        throw new Error(msg)
      }

      // Result could be array or stringified JSON
      let rows = []
      const result = res?.data?.result
      if (Array.isArray(result)) {
        rows = result
      } else if (typeof result === 'string') {
        rows = JSON.parse(result || '[]')
      } else {
        rows = result ?? []
      }

      // Normalize to base + specific
      const expanded = normalizeRowsForExport(rows)
      const byType = groupBy(expanded, r => r.productTypeKey)

      const wb = XLSX.utils.book_new()
      const typeKeys = Object.keys(byType).sort((a, b) => a.localeCompare(b))

      typeKeys.forEach(typeKey => {
        const items = byType[typeKey]
        const subcat = items?.[0]?.subcategoryName || ''
        const sheetName = sanitizeSheetName(`${typeKey} ${subcat}`.trim())

        // Build the union of product-specific keys across this group
        const specificKeySet = new Set()
        items.forEach(({ row }) => {
          Object.keys(row).forEach(k => {
            if (!BASE_COLUMNS.includes(k) && !EXTRA_XLSX_COLUMNS.includes(k))
              specificKeySet.add(k)
          })
        })
        const specificKeys = Array.from(specificKeySet).sort()

        // Final header = BASE_COLUMNS (exact order) + specific keys (sorted)
        const header = [...BASE_COLUMNS, ...EXTRA_XLSX_COLUMNS, ...specificKeys]

        // Build 2D array: first row header, then data in exact column order
        const aoa = [header]
        items.forEach(({ row }) => {
          aoa.push(header.map(col => row[col] ?? ''))
        })

        // Write sheet
        const ws = XLSX.utils.aoa_to_sheet(aoa)
        XLSX.utils.book_append_sheet(wb, ws, sheetName)
      })

      // Filename
      const fileName = [
        'APLSS_Report',
        params.brandMode || 'ALL',
        params.reviewedMode || 'AUTHORIZED',
        params.from || 'start',
        params.to || 'end',
      ].join('_')

      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
      const blob = new Blob([wbout], { type: 'application/octet-stream' })
      FileSaver.saveAs(blob, `${fileName}.xlsx`)
    } catch (err) {
      console.error('exportReport error:', err)
      throw err
    }
  }

  // Export CSV with exactly BASE_COLUMNS (20 columns), authorized only
  const exportAuthorizedCsv = async (params = {}) => {
    // Request only authorized rows from the API
    const qp = new URLSearchParams()
    qp.set('brandMode', params.brandMode || 'ALL')
    qp.set('reviewedMode', 'AUTHORIZED') // server maps this to fkApprovalStatus = 3
    if (params.from) qp.set('from', params.from)
    if (params.to) qp.set('to', params.to)
    if (params.category) qp.set('category', params.category)
    if (params.subcategory) qp.set('subcategory', params.subcategory)
    if (params.upc) qp.set('upc', params.upc)
    qp.set('offset', String(params.offset ?? 0))
    qp.set('fetch', String(params.fetch ?? 50000))

    const url = `${apiUrl}/products/report?${qp.toString()}`
    const res = await axios.get(url, { withCredentials: true })
    if (Number(res?.data?.statusCode) !== 200) {
      throw new Error(res?.data?.message || 'Report failed')
    }

    // Normalize result
    let rows = []
    const result = res?.data?.result
    rows = Array.isArray(result)
      ? result
      : typeof result === 'string'
      ? JSON.parse(result || '[]')
      : result ?? []

    // Hard guard: only status 3 (authorized)
    rows = rows.filter(r => Number(r?.fkApprovalStatus) === 3)

    if (rows.length === 0) {
      const e = new Error('NO_DATA')
      e.code = 'NO_DATA'
      throw e
    }

    // Map to base rows, then **emit only BASE_COLUMNS** in this order
    const mapped = rows.map(buildBaseRow)
    const aoa = [
      BASE_COLUMNS,
      ...mapped.map(r => BASE_COLUMNS.map(col => r[col] ?? '')),
    ]

    // To CSV
    const ws = XLSX.utils.aoa_to_sheet(aoa)
    const csv = XLSX.utils.sheet_to_csv(ws)
    const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8' })

    const fileName =
      [
        'APLSS_AuthorizedProducts',
        params.brandMode || 'ALL',
        params.from || 'start',
        params.to || 'end',
      ].join('_') + '.csv'

    FileSaver.saveAs(blob, fileName)
  }

  return (
    <ProductContext.Provider
      value={{
        products: state.products,
        current: state.current,
        contacts: state.contacts,
        vendors: state.vendors,
        contact: state.contact,
        vendor: state.vendor,
        saving: state.saving,
        deleteProduct,
        setCurrentProduct,
        updateProduct,
        clearCurrent,
        exportData,
        exportReport,
        exportAuthorizedCsv,
        getContacts,
        setCurrentContact,
        updateContact,
        getVendors,
        setCurrentVendor,
        updateVendor,
        getSubmittedProducts,
        getSubmittedBSProducts,
        getSubmittedNBSProducts,
        getInReviewProducts,
        getInReviewBSProducts,
        getInReviewNBSProducts,
        getReviewedProducts,
        getReviewedBSProducts,
        getReviewedNBSProducts,
        getProduct,
        loadProductImages,
        addProductReviewer,
        replaceProduct,
        notifyContactSuccess,
        notifyContactFail,
        setSaving,
      }}
    >
      <NotificationAlert ref={notificationAlert} />
      {children}
    </ProductContext.Provider>
  )
}

ProductState.propTypes = {
  children: PropTypes.node,
}

export default ProductState
